import { boxTextIcon } from '@workday/canvas-system-icons-web'
import { createIcon } from './create-icon'
import { canvasIconPaths } from './canvasIconPaths'

export const Description = createIcon({
  displayName: 'Description',
  paths: [
    'M128 341.333h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667zM896 554.667h-768c-23.552 0-42.667-19.115-42.667-42.667s19.115-42.667 42.667-42.667h768c23.552 0 42.667 19.115 42.667 42.667s-19.115 42.667-42.667 42.667zM640 768h-512c-23.552 0-42.667-19.115-42.667-42.667s19.115-42.667 42.667-42.667h512c23.552 0 42.667 19.115 42.667 42.667s-19.115 42.667-42.667 42.667z'
  ],
  canvasPaths: canvasIconPaths(boxTextIcon)
})
